import { render, staticRenderFns } from "./impacted-person.vue?vue&type=template&id=5785edfc&scoped=true"
import script from "./impacted-person.vue?vue&type=script&lang=js"
export * from "./impacted-person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785edfc",
  null
  
)

export default component.exports